import { faInfoCircle, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useContext, useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import ButtonIcon from "../common/ButtonIcon";
import FalconCardHeader from "../common/FalconCardHeader";
import PageHeader from "../common/PageHeader";
import {
  isIterableArray,
  Message,
  Or,
  PreloadState,
} from "../UI/preloading/PreloadState";
import Avatar from "../common/Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FullPagination from "../common/pagination/FullPagination";
import Flex from "../common/Flex";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "./../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import Swal from "sweetalert2";
import SupportLink from "../root/support/components/SupportLink";
import moment from "moment";
import { deleteArea, getCommonAreas } from "../../helpers/api/areas";
import { CurrencyContext } from "../../context/Context";

const CommonAreas = () => {
  const history = useHistory();
  const { role, token } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { baseCurrency } = useContext(CurrencyContext);
  const [params] = useState({ condominiun: selectedCondominium });
  const [images, setImages] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const {
    data,
    error,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getCommonAreas, selectedCondominium);

      console.log(selectedCondominium)

  useEffect(() => {
    let isMounted = true;
    isMounted && setImages(data.map(({ image }) => `${image}`));
    return () => {
      isMounted = false;
    };
  }, [data, token]);

  const dropArea = (id) => {
    Swal.fire({
      title: "¿Estas seguro?",
      text: "¿Quieres eliminar esta área?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#9341af",
      cancelButtonColor: "#bbb",
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.value) {
        try {
          const res = await deleteArea(id);
          if (res.code === SUCCESS_RESPONSE.Ok) {
            Toast.fire({
              type: "success",
              title: `Se ha eliminado el area satisfactoriamente.`,
            });
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      }
    });
  };
  console.log(images[0]);

  return (
    <>
      <PageHeader
        title="Áreas comunes"
        titleTag="h2"
        description={
          role === "manager"
            ? "Gestiona las areas comunes del condominio."
            : "Áreas comunes del condominio"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card>
        <FalconCardHeader title="Áreas comunes">
          {role === "manager" && (
            <Row>
              <Col>
                <ButtonIcon
                  icon={faPlus}
                  color="falcon-default"
                  onClick={() => history.push(`/dashboard/areas/create`)}
                >
                  Añadir área común
                </ButtonIcon>
              </Col>
            </Row>
          )}
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              <Table className="mb-0" style={{ overflow: "visible" }}>
                <thead>
                  <tr>
                    <th className="align-middle">Área</th>
                    <th className="align-middle">Descripción</th>
                    <th className="align-middle text-center">
                      Tarifa de depósito
                    </th>
                    <th className="align-middle text-center">
                      Tarifa de alquiler
                    </th>
                    <th className="align-middle text-center">
                      Fecha de creación
                    </th>
                    <th className="align-middle text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(
                    (
                      {
                        id,
                        name,
                        people_capacity,
                        description,
                        image,
                        rental_fee,
                        deposit_fee,
                        created_at,
                      },
                      i
                    ) => (
                      <tr key={id}>
                        <td className={classNames("align-middle")}>
                          <Flex align="center">
                            {image ? (
                              <>
                                <UncontrolledTooltip
                                  placement="top"
                                  target="ImageArea"
                                >
                                  Ampliar imágen
                                </UncontrolledTooltip>
                                <div
                                  id="ImageArea"
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setIsOpen(true);
                                    setIndex(i);
                                  }}
                                >
                                  <Avatar
                                    rounded={"soft"}
                                    className="mr-2"
                                    src={image}
                                  />
                                </div>
                              </>
                            ) : (
                              <div
                                className="mr-2"
                                style={{ width: "32px" }}
                              ></div>
                            )}
                            <p className="mb-0">{name}</p>
                          </Flex>

                          {isOpen && (
                            <Lightbox
                              reactModalStyle={{ zIndex: 1250 }}
                              mainSrc={images[index]}
                              onCloseRequest={() => setIsOpen(false)}
                            />
                          )}
                        </td>
                        <td className="align-middle">
                          <p className="mb-0">
                            {description || "Sin descripción"}
                          </p>
                        </td>
                        <td className="text-center align-middle">
                          {deposit_fee ? (
                            <NumberFormat
                              displayType="text"
                              prefix={`${baseCurrency.symbol} `}
                              thousandSeparator
                              fixedDecimalScale
                              decimalScale={2}
                              value={deposit_fee}
                            />
                          ) : (
                            "NO"
                          )}
                        </td>
                        <td className="text-center align-middle">
                          {rental_fee ? (
                            <NumberFormat
                              displayType="text"
                              prefix={`${baseCurrency.symbol} `}
                              thousandSeparator
                              fixedDecimalScale
                              decimalScale={2}
                              value={rental_fee}
                            />
                          ) : (
                            "NO"
                          )}
                        </td>
                        <td className="text-center align-middle">
                          {moment(created_at).format("DD/MM/YYYY")}
                        </td>
                        <td className="align-middle text-center">
                          <UncontrolledDropdown direction="left">
                            <DropdownToggle color="falcon-default" size="sm">
                              <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem
                                onClick={() =>
                                  history.push(
                                    `/dashboard/areas/${id}/reservations`,
                                    { rental_fee, deposit_fee }
                                  )
                                }
                              >
                                Ver reservaciones
                              </DropdownItem>
                              {role === "manager" && <DropdownItem divider />}
                              {role === "manager" && (
                                <DropdownItem
                                  onClick={() =>
                                    history.push(
                                      `/dashboard/areas/${id}/edit`,
                                      {
                                        area: {
                                          id,
                                          name,
                                          people_capacity,
                                          description,
                                          image,
                                          rental_fee,
                                          deposit_fee,
                                          created_at,
                                        },
                                      }
                                    )
                                  }
                                >
                                  Editar
                                </DropdownItem>
                              )}
                              {role === "manager" && (
                                <DropdownItem
                                  className="text-danger"
                                  onClick={() => dropArea(id)}
                                >
                                  Eliminar área
                                </DropdownItem>
                              )}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            </Or>
            <Or value={false}>
              <Or cond={!error ? true : false}>
                <Or value={true}>
                  <Message
                    color={"info"}
                    className="p-3"
                    align="left"
                    icon={faInfoCircle}
                  >
                    No hay areas comunes para mostrar.
                  </Message>
                </Or>
                <Or value={false}>
                  <Message
                    color={"danger"}
                    className="p-3"
                    align="left"
                    icon={faInfoCircle}
                  >
                    Ha ocurrido un error.
                  </Message>
                </Or>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        {isIterableArray(data) && (
          <CardFooter className="border-top">
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"áreas"}
              perPage={perPage}
            />
          </CardFooter>
        )}
      </Card>
    </>
  );
};

export default CommonAreas;
